import { RichText, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import pnMergetagReplacer from '../../../lib/utils/pnMergeTagReplacer';
import studyConditionMergeTagReplacer from '../../../lib/utils/studyConditionMergeTagReplacer';
import { getPrimaryStudyAndConditionNames } from '../../../lib/utils/siteHelper';
import getCallCenterNumber from '../../../store/selectors/getCallCenterNumber';
import { RootState } from '../../../store/store';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';

type StRichTextItemProps = {
  inheritLinkColor?: boolean;
};

export const StRichText = styled(RichText, {
  shouldForwardProp: (prop) => prop !== 'inheritLinkColor',
})<StRichTextItemProps>(({ inheritLinkColor }) => ({
  '& a': {
    color: inheritLinkColor ? 'inherit' : 'none',
  },
}));

const RichTextWithStudyPnMergeTag = ({ field, cssClassName, inheritLinkColor }: any) => {
  const { sitecoreContext } = useSitecoreContext();
  const callCenterNumber = getCallCenterNumber(sitecoreContext);
  const siteSettings: any = sitecoreContext?.siteSettings;
  const cdpData = useSelector((state: RootState) => state.cdpData);
  const screenerOutcomeParameter = useSelector(
    (state: RootState) => state.megaScreener?.screenerOutcomeParameter
  );
  const { primaryStudyName, primaryConditionName } = getPrimaryStudyAndConditionNames(
    siteSettings,
    cdpData,
    screenerOutcomeParameter
  );
  const [content, setContent] = useState(field);

  useEffect(() => {
    if (callCenterNumber?.value || primaryStudyName || primaryConditionName) {
      const newContent = pnMergetagReplacer(field?.value, String(callCenterNumber?.value), true);
      const newContentWithStudyCondition = studyConditionMergeTagReplacer(
        newContent,
        primaryStudyName,
        primaryConditionName
      );
      setContent({ ...content, value: newContentWithStudyCondition });
    }
  }, [callCenterNumber?.value, primaryStudyName, primaryConditionName]);

  return (
    <StRichText
      field={content}
      className={cssClassName ? cssClassName : ''}
      inheritLinkColor={inheritLinkColor ? inheritLinkColor : false}
    ></StRichText>
  );
};

export default RichTextWithStudyPnMergeTag;
